import {Component, Inject, OnInit} from '@angular/core';
import {MatchingVccDetails} from '../../model/match-vcc';
import {MatchingVccService} from '../../service/matching-vcc.service';
import {MerchantsService} from 'src/infrastructure/merchants/service/merchants.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'matching-vcc-detail-v2',
    templateUrl: '../matching-vcc-detail/matching-vcc-detail.component.html',
    standalone: false
})
export class MatchingVccDetailV2Component implements OnInit{
    details?:MatchingVccDetails;

    constructor(
        private matchingVccService: MatchingVccService,
        private merchantsService: MerchantsService,
        @Inject(MAT_DIALOG_DATA) public data: { id: string, fmsBookingId: number }
    ){}

    ngOnInit(): void {
        this.matchingVccService.getMatchingDetails(this.data.id, this.data.fmsBookingId).subscribe((data)=>{
            this.details = data;
            this.merchantsService.merchants$.subscribe((data)=>{
                const matchedMerchant = data.filter((merchant)=>{
                    return merchant.merchantGuid === this.details?.merchantGuid;
                });
                
                this.details!.connexPayCurrency = `${matchedMerchant[0].currencyName}`;
                this.details!.vccCurrency = `${matchedMerchant[0].currencyName}`;
            });
        });
    }
}
